 
import { motion } from "framer-motion"
import "../styles/Header.css"

function Header() {
  return (
    <header className="llheader">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1>
          <span className="title-highlight">Linked List</span> Visualizer
        </h1>
        <p>Interactive visualization of linked list data structures</p>

        <div className="llheader-decoration">
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
          <div className="decoration-item"></div>
        </div>
      </motion.div>
    </header>
  )
}

export default Header
